const CalltoActionButton = ({ submitFunction, name }) => {
  return <button onClick={() => submitFunction()}>{name}</button>;
};

export default CalltoActionButton;
